var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoTriangle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 28,
    viewBox: "0 0 30 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.4 20.8586L18.8898 2.65394C17.1731 -0.353398 12.8319 -0.353398 11.1213 2.65394L0.604885 20.8586C-1.11183 23.8659 1.0248 27.6019 4.48911 27.6019H25.4788C28.9431 27.6019 31.1167 23.8288 29.4 20.8586ZM14.9994 23.5633C14.0854 23.5633 13.3259 22.8038 13.3259 21.8898C13.3259 20.9759 14.0854 20.2163 14.9994 20.2163C15.9133 20.2163 16.6729 20.9759 16.6358 21.933C16.679 22.8038 15.8763 23.5633 14.9994 23.5633ZM16.5247 12.7443C16.4506 14.0411 16.3703 15.3317 16.2962 16.6285C16.2591 17.0484 16.2591 17.4313 16.2591 17.845C16.2221 18.5305 15.6848 19.0616 14.9994 19.0616C14.3139 19.0616 13.7828 18.5675 13.7396 17.8821C13.6285 15.8628 13.5111 13.8805 13.4 11.8612C13.3629 11.3302 13.3259 10.7929 13.2827 10.2618C13.2827 9.38496 13.7767 8.66245 14.5795 8.43397C15.3822 8.24254 16.1788 8.6254 16.5247 9.38496C16.642 9.65049 16.679 9.91603 16.679 10.2248C16.642 11.0708 16.5617 11.9106 16.5247 12.7443Z",
    fill: "#DD6369"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoTriangle);
export default __webpack_public_path__ + "static/media/info_triangle.6a1dee6c63460bef0fc8fe59d16f2bd2.svg";
export { ForwardRef as ReactComponent };